// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListUnionCourseModuleModuleLecturerResponseData } from './genericApiResponseListUnionCourseModuleModuleLecturerResponseData';
import type { GenericApiResponseListUnionCourseModuleModuleLecturerResponseMessage } from './genericApiResponseListUnionCourseModuleModuleLecturerResponseMessage';
import type { GenericApiResponseListUnionCourseModuleModuleLecturerResponsePagination } from './genericApiResponseListUnionCourseModuleModuleLecturerResponsePagination';
import type { GenericApiResponseListUnionCourseModuleModuleLecturerResponseError } from './genericApiResponseListUnionCourseModuleModuleLecturerResponseError';

export interface GenericApiResponseListUnionCourseModuleModuleLecturerResponse {
  data?: GenericApiResponseListUnionCourseModuleModuleLecturerResponseData;
  message?: GenericApiResponseListUnionCourseModuleModuleLecturerResponseMessage;
  pagination?: GenericApiResponseListUnionCourseModuleModuleLecturerResponsePagination;
  error?: GenericApiResponseListUnionCourseModuleModuleLecturerResponseError;
  statusCode?: number;
}
